import React, { useEffect, useState } from 'react'
import { changeMypageApi, deleteUserApi, getMyPageApi } from '../../api/user'
import { useUserStore } from '../../store/userStore'
import { mypageDefaultSchema } from '../../utils/validation/yup/user/userYup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import { swalAlert, swalErrorAlert } from '../../utils/swal/swal'

const MypageForm = () => {
	/* zustand */
	const { userInfo, logoutAction } = useUserStore((state) => state)

	/* useState */
	const [privateInfo, setPrivateInfo] = useState(null)

	/* React-hook-form */
	const schema = mypageDefaultSchema
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors }
	} = useForm({
		resolver: yupResolver(schema),
	})

	/* useEffect */
	useEffect(() => {
		getMypageData()
	}, [])

	useEffect(() => {
		if (privateInfo) {
			reset({
				user_name: privateInfo.user_name,
				tel: privateInfo.tel
			});
		} else {
			reset()
		}
	}, [privateInfo]);

	/* Methods */
	const getMypageData = async () => {
		try {
			const userId = userInfo.user_id
			const response = await getMyPageApi(userId)
			const privateInfoData = response?.data?.resData
				? response?.data?.resData
				: null
			setPrivateInfo(privateInfoData)

		} catch (error) {
			setPrivateInfo(null)
			swalErrorAlert('개인정보 조회 에러', '개인정보를 불러오는 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.', 'error', '확인',)
			return

		}
	}

	const onSubmitForm = async (formData) => {
		// API 요청
		try {
			let requestData = formData
			await changeMypageApi(requestData)

			swalAlert('개인정보 수정 성공', '비밀번호가 변경되었습니다.<br> 다시 로그인 해주세요', 'success', '확인', logoutAction)
			return
		} catch (error) {
			swalErrorAlert('개인정보 수정 실패', '개인정보 수정 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.', 'error', '확인')
			return
		}
	}

	const onClickDeleteUser = async () => {
		Swal.fire({
			title: '회원 탈퇴',
			html: '정말로 탈퇴하시겠습니까?',
			icon: 'warning',
			showCancelButton: true, // 취소 버튼 표시
			confirmButtonText: '회원 탈퇴',
			cancelButtonText: '취소',
			reverseButtons: true, // 버튼 순서 변경
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					await deleteUserApi()
					// 홈으로 이동
					Swal.fire({
						title: '회원 탈퇴 완료',
						icon: 'success',
						confirmButtonText: '확인',
					}).then(logoutAction())
				} catch (error) {
					Swal.fire({
						title: '회원 탈퇴 실패',
						html: '회원 탈퇴 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.',
						icon: 'error',
						confirmButtonText: '확인',
					})
					return
				}
			}
		})
		return
	}

	return (
		<form onSubmit={handleSubmit(onSubmitForm)}>
			<div className="row gx-3 gy-2 mb-4">
				<div className="col-12">
					<label htmlFor="email" className="form-label">
						이메일
					</label>
					<input
						type="text"
						id="email"
						className="form-control"
						defaultValue={userInfo.email}
						readOnly
						disabled
					/>
				</div>
			</div>

			<div className="row gx-3 gy-2 mb-4">
				<div className="col-12">
					<label htmlFor="userName" className="form-label">
						이름
					</label>
					<input
						type="text"
						id="userName"
						className="form-control"
						maxLength={40}
						placeholder="이름을 입력해 주세요"
						{...register('user_name')}
					/>
					{errors.user_name && (
						<p className="text-small text-danger">{errors.user_name.message}</p>
					)}
				</div>
			</div>

			<div className="row gx-3 gy-2 mb-4">
				<div className="col-12">
					<label htmlFor="tel" className="form-label">휴대전화번호(-제외)</label>
					<input
						type="text"
						name="tel"
						id="tel"
						className={
							errors.tel ? 'form-control border-danger' : 'form-control'
						}
						maxLength={11}
						placeholder="휴대전화 번호를 입력해 주세요"
						{...register('tel', {
							onChange: (e) => {
								e.target.value = e.target.value.replace(/[^0-9]/g, '')
							}
						})}
					/>
					{errors.tel && (
						<p className="text-small text-danger">{errors.tel.message}</p>
					)}
				</div>
			</div>
			<hr className="my-4" />

			<div>
				<button type="submit" className="w-100 btn btn-primary btn-lg">수정하기</button>
			</div>
			<hr className="my-4" />

			<div className="text-end">
				<button type="button"
					className="btn btn-outline-secondary"
					onClick={onClickDeleteUser}
				>
					회원탈퇴
				</button>
			</div>
		</form>
	)
}

export default MypageForm
